import isEmpty from 'lodash/isEmpty';
import { MOCK_DISPUTE_DATA } from '../mockedData';

const getDisputesSectionData = ({ payment = {} }) => {
  return isEmpty(payment?.dispute) ? MOCK_DISPUTE_DATA : payment?.dispute;
};

export { getDisputesSectionData };
